export default {
  "content": "<path d=\"M36.65 0H7.354A7.354 7.354 0 000 7.354V36.65a7.354 7.354 0 007.354 7.354H36.65a7.353 7.353 0 007.354-7.354V7.354A7.352 7.352 0 0036.65 0zm-.646 33.685a2.32 2.32 0 01-2.32 2.32H10.325a2.32 2.32 0 01-2.321-2.32v-23.36a2.32 2.32 0 012.321-2.321h23.359a2.32 2.32 0 012.32 2.321z\"/><path d=\"M17.333 28.003c-.736 0-1.332-.6-1.332-1.339V17.34c0-.739.596-1.339 1.332-1.339h9.338c.738 0 1.332.6 1.332 1.339v9.324c0 .739-.594 1.339-1.332 1.339z\"/>",
  "attrs": {
    "fill": "#2e3b4e",
    "height": "44",
    "viewBox": "0 0 44 44",
    "width": "44",
    "xmlns": "http://www.w3.org/2000/svg"
  }
};